import React, { useState, useEffect } from "react";
import classnames from "classnames/bind";
import { FormGroup, FormControl, ControlLabel, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import FileUploader from "react-firebase-file-uploader";
import { ThreeBounce } from "better-react-spinkit";
import dayjs from "dayjs";

import { getBoard, getImage } from "src/utils/Firebase";

import css from "./NewBoard.scss";

const cx = classnames.bind(css);
const moduleName = "NewBoard";

const NewBoard = ({ board }) => {
  const [redirect, setRedirect] = useState(false);
  const [imageNum, setImageNum] = useState(0);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [avatarURL, setAvatarURL] = useState([]);
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => {
    if (!board.data) {
      setRedirect(true);
    }
  }, []);

  const handleUploadStart = () => setIsUploading(true);
  const handleProgress = () => {};
  const handleUploadError = (error) => {
    setIsUploading(false);
    console.error(error);
  };
  const handleUploadSuccess = (filename) => {
    setImageNum((n) => n + 1);
    setIsUploading(false);
    getImage()
      .child(filename)
      .getDownloadURL()
      .then((url) => setAvatarURL((prev) => [...prev, url]));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let boardId = board.data[0].id + 1;
    if (!boardId) boardId = 0;

    const newTask = {
      id: boardId,
      title,
      content,
      imageNum,
      date: dayjs().format("YYYY-MM-DD"),
      imgUrl: avatarURL,
    };

    getBoard()
      .child(boardId)
      .set(newTask)
      .then(() => setRedirect(true));
  };

  if (redirect) return <Redirect to="/board" />;

  return (
    <div className={cx(`${moduleName}`)}>
      <div className={cx(`${moduleName}-header`)}>
        <div className={cx(`${moduleName}-header-wrapper`)} />
        <h2>추억만들기</h2>
        <h4>글을 작성하는 화면입니다.</h4>
      </div>
      <div className={cx(`${moduleName}`)}>
        <form onSubmit={handleSubmit}>
          <FormGroup controlId="formTitle" validationState="success">
            <ControlLabel>제목</ControlLabel>
            <FormControl
              type="text"
              placeholder="제목"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormGroup>
          <FormGroup controlId="formContent" validationState="success">
            <ControlLabel>내용</ControlLabel>
            <FormControl
              componentClass="textarea"
              placeholder="내용"
              value={content}
              className={cx(`${moduleName}-content`)}
              onChange={(e) => setContent(e.target.value)}
            />
          </FormGroup>
          <p>첨부한 파일: {imageNum}</p>
          {avatarURL.map((val, i) => (
            <img key={i} width="50px" height="50px" src={val} alt="upload" />
          ))}
          <FileUploader
            accept="image/*"
            name="avatar"
            filename={() =>
              board.data &&
              "board" +
                (board.data[0].id + 1) +
                (imageNum !== 0 ? "-" + imageNum : "")
            }
            storageRef={getImage()}
            onUploadStart={handleUploadStart}
            onUploadError={handleUploadError}
            onUploadSuccess={handleUploadSuccess}
            onProgress={handleProgress}
          />
          {isUploading ? (
            <div>
              <ThreeBounce size={15} color="#265E4B" />
              <p>사진이 업로드 중입니다.!</p>
            </div>
          ) : (
            <Button type="submit">Submit</Button>
          )}
        </form>
      </div>
    </div>
  );
};

export default connect(({ board }) => ({ board }))(NewBoard);



// WEBPACK FOOTER //
// ./src/App/pages/Home/pages/Boards/components/NewBoard.js